import { useEffect, useState } from 'react';
import axios from 'axios';
import { PostCard } from '../components/PostCard';
import { Sidebar } from '../components/Sidebar';
import { FileText } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get(`${API}/articles?category=article&limit=50`);
        setArticles(response.data);
      } catch (error) {
        console.error('Error fetching articles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  return (
    <div className="min-h-screen py-16" data-testid="articles-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex items-center gap-3 mb-12">
          <FileText className="text-primary" size={40} />
          <div>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Artigos</h1>
            <p className="text-muted-foreground mt-2">Conteúdo aprofundado sobre Bitcoin e economia</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            {loading ? (
              <div className="text-center py-12">Carregando...</div>
            ) : articles.length === 0 ? (
              <div className="text-center py-12 text-muted-foreground">
                Nenhum artigo disponível no momento.
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {articles.map((article) => (
                  <PostCard key={article.id} article={article} baseUrl="/artigos" />
                ))}
              </div>
            )}
          </div>

          <div className="lg:sticky lg:top-24 h-fit">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;